import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';

const AuthCallbackV2 = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (window.hasNavigated) return;
    window.hasNavigated = true;

    const params = new URLSearchParams(window.location.search);
    const urlParams = Object.fromEntries(params.entries());
    console.log("🔍 Gmail v2 AuthCallback - Full URL:", window.location.href);
    console.log("🔍 Gmail v2 AuthCallback - URL params:", urlParams);

    const success = params.get("success");
    const error = params.get("error");
    const isAdding = params.get("add")?.toLowerCase() === "true";
    const email = params.get("email");
    const token = params.get("token");

    console.log("🔍 Gmail v2 AuthCallback - Parsed values:", {
      success,
      error,
      isAdding,
      email,
      token: token ? token.substring(0, 20) + "..." : "none",
      hasOpener: !!window.opener
    });

    const handleError = (msg = "Gmail v2 authentication failed") => {
      console.error("❌ Gmail v2 AuthCallback Error:", msg);
      message.error(msg);

      setTimeout(() => {
        if (window.opener) {
          console.log("📤 Gmail v2 - Posting error message to opener");
          window.opener.postMessage("gmail_v2_account_add_error", "*");
          window.close();
        } else {
          console.log("🔄 Gmail v2 - Redirecting to manage accounts");
          navigate("/manage-accounts");
        }
      }, 2000);
    };

    const handleSuccess = () => {
      console.log("✅ Gmail v2 - Account added successfully");
      message.success("Gmail account added successfully!");
      
      if (window.opener) {
        console.log("📤 Gmail v2 - Posting success message to opener");
        window.opener.postMessage("gmail_v2_account_added", "*");
        setTimeout(() => {
          if (!window.closed) {
            console.log("🔒 Gmail v2 - Closing popup window");
            window.close();
          }
        }, 1000);
      } else {
        console.log("🔄 Gmail v2 - Redirecting to manage accounts");
        navigate("/manage-accounts", { state: { accountAdded: true } });
      }
    };

    // Handle errors first
    if (error) {
      console.error("❌ Gmail v2 - Error parameter detected:", error);
      return handleError(`Gmail v2 authentication failed: ${error}`);
    }

    // Handle Gmail account addition success
    if (success === "true" && isAdding) {
      console.log("🟡 Gmail v2 - Processing successful account addition");
      console.log("🔍 Gmail v2 - Account email:", email);
      
      // ✅ Backend v2 OAuth flow already saved the account to Firestore
      // No additional API calls needed - single source of truth
      console.log("✅ Gmail v2 - Account was saved by backend OAuth callback");
      handleSuccess();
    }
    // Handle other success cases
    else if (success === "true") {
      console.log("🟢 Gmail v2 - General success case");
      handleSuccess();
    }
    // Invalid response
    else {
      console.warn("⚠️ Gmail v2 - Invalid authentication response");
      console.warn("⚠️ Gmail v2 - Expected: success=true&add=true, got:", { success, isAdding });
      handleError("Invalid Gmail v2 authentication response.");
    }

  }, [navigate]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f0f2f5',
      flexDirection: 'column'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h2>Gmail v2 Authentication</h2>
        <p>Completing Gmail account setup...</p>
        <div style={{ marginTop: '20px' }}>
          <div className="ant-spin ant-spin-lg" />
        </div>
        <p style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
          This window will close automatically once setup is complete.
        </p>
        <div style={{ marginTop: '20px', fontSize: '12px', color: '#999' }}>
          <p>Debug info:</p>
          <p>URL: {window.location.href}</p>
          <p>Params: {JSON.stringify(Object.fromEntries(new URLSearchParams(window.location.search)))}</p>
        </div>
      </div>
    </div>
  );
};

export default AuthCallbackV2;